'use strict';

/**
 * library
 */
import Snap from 'snapsvg-cjs';
import 'jquery-scrollify';
import VueAnalytics from 'vue-analytics';

/**
 * app
 */
export const app = (() => {

    let imgPath = '../';
    let imgPath_2 = '../';
    let preloadPath = './';
    let firstPlay = true;
    let loadCondition;
    let current = 0;

    /**
     * init
     */
    const init = () => {

        const app = new Vue();
        const loadScrollify = () => {
            if ($('.js-scrSec').length === 5) {
                $(function () {
                    $.scrollify({
                        section: ".js-scrSec",
                        setHeights: false,
                        updateHash: false,
                        offset: 0,
                        easing: "easeOutExpo",
                        scrollSpeed: 600,
                        before: function (i, box) {
                            current = i;
                        },
                    });
                });
                $('html,body').animate({ scrollTop: 0 }, 10);
                $.scrollify.update();

                clearInterval(loadCondition);
                return;
            }
        }
        const Top = {
            template: '#top',
            props: ['page'],
            created: function () {
                this.$parent.page = 'home';
                $('body').removeClass('is-loading-question is-loading-result');

                $(window).on('resize', function () {
                    if ($('.is-scrActive').length) {
                        if (current) {
                            var currentScrl = $('.js-scrSec').eq(current).offset().top;
                            $(window).scrollTop(currentScrl);
                        }
                    }
                });

                // $(window).on('load', function () {
                //     $(function () {
                //         $.scrollify({
                //             section: ".js-scrSec",
                //             setHeights: false,
                //             updateHash: false,
                //             offset: 0,
                //             easing: "easeOutExpo",
                //             scrollSpeed: 600,
                //             before: function (i, box) {
                //                 current = i;
                //             },
                //         });
                //     });
                //     $('html,body').animate({ scrollTop: 0 }, 10);
                //     $.scrollify.update();
                // });
                loadCondition = setInterval(loadScrollify, 100);

                $(window).on('scroll load', function () {
                    if ($('.is-scrActive').length) {
                        setTimeout(() => {
                            $.scrollify.update();

                            if ($.scrollify.current().hasClass('js-inview')) {
                                $.scrollify.current().addClass('is-inview');
                            }

                            if ($.scrollify.current().hasClass('js-lastSec')) {
                                $('.js-scrBtn').addClass('is-hide');
                                $('.js-stBtn').removeClass('is-hide');
                            }
                            else {
                                $('.js-scrBtn').removeClass('is-hide');
                                $('.js-stBtn').addClass('is-hide');
                            }
                        }, 100);
                    }
                });

                for (let i = 1; i <= 8; i++) {
                    const image = new Image();
                    image.src = preloadPath + 'assets/img/question/img_q0' + i + '.jpg';
                }
                //preload

                const per = ['100', '80', '60', '40', '20', '0'];

                for (let i = 0; i < per.length; i++) {
                    const image1 = new Image();
                    const image2 = new Image();
                    const image3 = new Image();
                    image1.src = preloadPath + 'assets/img/result/bln_result-' + per[i] + '.png';
                    image2.src = preloadPath + 'assets/img/result/img_fish-' + per[i] + '.png';
                    image3.src = preloadPath + 'ogp_' + per[i] + '.jpg';
                }
                //preload

                const image1 = new Image();
                const image2 = new Image();
                const image3 = new Image();
                const image4 = new Image();
                image1.src = preloadPath + 'assets/img/logo-movie.png';
                image2.src = preloadPath + 'assets/img/txt_date.png';
                image3.src = preloadPath + 'assets/img/logo_s.png';
                image4.src = preloadPath + 'assets/img/question/img_q01.jpg';
                // preload

                const image5 = new Image();
                const image6 = new Image();
                image5.src = preloadPath + 'assets/img/result/img_result.png';
                image6.src = preloadPath + 'assets/img/result/img_money.png';
                // preload
            },
            data: function () {
                return {
                }
            },
            methods: {
                start: function () {
                    $('.layout-loading').css({ 'transition-duration': '0.3s' });
                    $('body').removeClass('is-loaded');

                    let pathSplit = location.pathname.split('question');
                    var path = pathSplit[0];
                    // URL書き換え
                    window.history.replaceState(null, null, path);

                    setTimeout(() => {
                        router.push('question');
                        $.scrollify.destroy();
                    }, 600);
                }
            }
        }
        const Question = {
            template: '#question',
            props: ['page', 'result_num'],
            mounted() {

                let pathSplit = location.pathname.split('result/');
                var path = pathSplit[0];

                window.history.replaceState(null, null, path);
                // URL書き換え
                window.history.pushState(null, null, path + 'question/');
                $('body').addClass('is-page-question');
            },
            created: function () {
                imgPath = '../';
                preloadPath = './';

                this.$parent.page = 'question';
                this.$parent.result_num = 0;
                window.scrollTo(0, 0);

                setTimeout(() => {
                    $('body').addClass('is-loaded');
                }, 500);
            },
            data: function () {
                return {
                    page_num: "0",
                    img: "",
                    alt: "",
                    text: "",
                    vslname: "./assets/img/question/img_q01.jpg",
                    vslalt: "001",
                    text: "強気な感じで何かを<br>頼まれると断れない",
                    qs: [
                        {
                            vslname: "assets/img/question/img_q01.jpg",
                            vslalt: "001",
                            text: "強気な感じで何かを<br>頼まれると断れない",
                            y_next: "2",
                            n_next: "3"
                        },
                        {
                            vslname: "assets/img/question/img_q02.jpg",
                            vslalt: "002",
                            text: "言い争いは苦手",
                            y_next: "6",
                            n_next: "3"
                        },
                        {
                            vslname: "assets/img/question/img_q03.jpg",
                            vslalt: "003",
                            text: "誰とでも<br>すぐ仲良くなれる",
                            y_next: "7",
                            n_next: "4"
                        },
                        {
                            vslname: "assets/img/question/img_q04.jpg",
                            vslalt: "004",
                            text: "辛いときこそ<br>笑顔が大事",
                            y_next: "8",
                            n_next: "5"
                        },
                        {
                            vslname: "assets/img/question/img_q05.jpg",
                            vslalt: "005",
                            text: "心を許せる友人がいる",
                            y_next: "rslt_5",
                            n_next: "rslt_6"
                        },
                        {
                            vslname: "assets/img/question/img_q06.jpg",
                            vslalt: "006",
                            text: "サングラスをかけるのに<br>抵抗がある",
                            y_next: "rslt_1",
                            n_next: "7"
                        },
                        {
                            vslname: "assets/img/question/img_q07.jpg",
                            vslalt: "007",
                            text: "わりと押しに弱い。",
                            y_next: "rslt_2",
                            n_next: "8"
                        },
                        {
                            vslname: "assets/img/question/img_q08.jpg",
                            vslalt: "008",
                            text: "変装しても<br>すぐバレる自信がある",
                            y_next: "rslt_3",
                            n_next: "rslt_4"
                        }
                    ]
                }
            },
            methods: {
                yes: function () {
                    var next = this.qs[this.page_num].y_next;

                    if (next.indexOf("rslt_") < 0) {
                        $('body').addClass('is-loading-question');
                    }

                    setTimeout(() => {
                        window.scrollTo(0, 0);

                        if (next.indexOf("rslt_") >= 0) {
                            $('body').removeClass('is-loaded is-page-question');
                            $('body').addClass('is-loading-result');
                            this.$parent.result_num = next.replace("rslt_", "") - 1;

                            setTimeout(() => {
                                router.push('result');
                                window.scrollTo(0, 0);
                            }, 300);
                        } else {
                            this.page_num = next - 1;
                            this.vslname = imgPath + this.qs[this.page_num].vslname;
                            this.vslalt = this.qs[this.page_num].vslalt;
                            this.text = this.qs[this.page_num].text.replace(/\n/g, '<br/>');
                            $('body').removeClass('is-loading-question');
                        }
                    }, 350);
                },
                no: function () {
                    var next = this.qs[this.page_num].n_next;

                    if (next.indexOf("rslt_") < 0) {
                        $('body').addClass('is-loading-question');
                    }

                    setTimeout(() => {
                        window.scrollTo(0, 0);

                        if (next.indexOf("rslt_") >= 0) {
                            $('body').removeClass('is-loaded is-page-question');
                            $('body').addClass('is-loading-result');
                            this.$parent.result_num = next.replace("rslt_", "") - 1;

                            setTimeout(() => {
                                router.push('result');
                                window.scrollTo(0, 0);
                            }, 300);
                        } else {
                            this.page_num = next - 1;
                            this.vslname = imgPath + this.qs[this.page_num].vslname;
                            this.vslalt = this.qs[this.page_num].vslalt;
                            this.text = this.qs[this.page_num].text.replace(/\n/g, '<br/>');
                            $('body').removeClass('is-loading-question');
                        }
                    }, 350);
                }
            }
        }
        const Result = {
            template: '#result',
            props: ['page', 'result_num'],
            mounted() {
                let path = location.pathname.replace('question/', '');
                let pageNum = Number(this.$parent.result_num) + 1;
                // URL書き換え
                window.history.pushState(null, null, path + 'result/0' + pageNum + '/');
                $('body').addClass('is-page-result');
            },
            created: function () {
                // imgPath = '../../';
                imgPath = '../';

                this.$parent.page = 'result';
                this.vslname = imgPath + this.results[this.$parent.result_num].vslname;
                this.vslalt = this.results[this.$parent.result_num].vslalt;
                this.imgname = imgPath + this.results[this.$parent.result_num].imgname;
                this.imgalt = this.results[this.$parent.result_num].imgalt;
                this.text01 = this.results[this.$parent.result_num].text01;
                this.text02 = this.results[this.$parent.result_num].text02;
                this.text03 = this.results[this.$parent.result_num].text03;
                this.ogpname = imgPath + this.results[this.$parent.result_num].ogpname;
                this.ogpalt = this.results[this.$parent.result_num].ogpalt;
                let pageNum = Number(this.$parent.result_num) + 1;

                let shareText = String(encodeURIComponent(this.shareHeader + this.results[this.$parent.result_num].share + this.shareFooter1 + this.results[this.$parent.result_num].shareUrl + this.shareFooter2)).replace(/%7C/g, '%0D%0A');

                this.url = "https://twitter.com/intent/tweet?text=" + shareText;

                if (this.$parent.result_num === 5) {
                    $('body').addClass('result-000');
                }

                setTimeout(() => {
                    $('.layout-loading').css({ 'transition-duration': '0.6s' });
                    $('body').addClass('is-loaded');
                }, 1800);

                setTimeout(() => {
                    var $wave = Snap('.ani-path');//動かしたいpath要素
                    var path = [
                        'M0,17.78C33.31,17.78,49,.14,49,.14S62.69,17.78,96,17.78,145,.14,145,.14s13.71,17.64,47,17.64S241,.14,241,.14s13.71,17.64,47,17.64S337,.14,337,.14s13.71,17.64,47,17.64S433,.14,433,.14s13.71,17.64,47,17.64S529,.14,529,.14s13.71,17.64,47,17.64S625,.14,625,.14s13.71,17.64,47,17.64S721,.14,721,.14s13.71,17.64,47,17.64V55H0Z', //パスその１
                        'M0,0S18,18.14,49,18.14,96-.22,96-.22s17,18.36,49,18.36S192-.22,192-.22s17,18.36,49,18.36S288-.22,288-.22s16,18.36,49,18.36S384-.22,384-.22s18,18.36,49,18.36S480-.22,480-.22s17,18.36,49,18.36S576-.22,576-.22s18,18.36,49,18.36S672-.22,672-.22s16,18.36,49,18.36S768-.22,768-.22V55H0Z' //パスその2
                    ];
                    var indexPath = 0;
                    var DURATION = 1200;
                    var playAnimation = function () {
                        //今がパス1ならパス0へアニメーション
                        if (indexPath === 0) {
                            $wave.animate(
                                { d: path[0] }, DURATION, playAnimation);
                            indexPath = 1;
                            //今がパス0ならパス1へアニメーション
                        } else {
                            $wave.animate(
                                { d: path[1] }, DURATION, playAnimation);
                            indexPath = 0;
                        }
                    }
                    playAnimation();
                }, 100);
            },
            data: function () {
                return {
                    vslname: "",
                    vslalt: "",
                    imgname: "",
                    imgalt: "",
                    text01: "",
                    text02: "",
                    url: "",
                    shareHeader: "おサカナ度診断 深海の生きもの編|🐟わたしのおサカナ度は…||", //改行を「|」に置換しています。出力時に改行コード（URLエンコード）に再置換されます。
                    shareFooter1: "||#あなたのおサカナ度を診断💴|設問に答えて結果をシェアしよう👇|https://confidenceman-movie.com/shindan2|",
                    shareFooter2: "|#コンフィデンスマンJP 7/23(木・祝)公開",
                    results: [
                        {
                            vslname: "assets/img/result/bln_result-100.png",
                            vslalt: "あなたのおサカナ度 100%",
                            imgname: "assets/img/result/img_fish-100.png",
                            imgalt: "「メンダコ」タイプ",
                            text01: "深海のアイドル<br>(墨は吐きません)",
                            text02: "素直で自然体。愛されキャラで自分を偽ったり誰かと争うのが苦手なあなた。<br>誰かの噂話も疑いなく信じてしまう方ではありませんか?",
                            text03: "…ズバリおサカナ度No.1なあなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_100.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度100% 深海のアイドル(墨は吐きません)「メンダコ」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 100% ＞|深海のアイドル|(墨は吐きません)|🎣メンダコ タイプ",
                            shareUrl: "pic.twitter.com/cVfW2SdwpE"
                        },
                        {
                            vslname: "assets/img/result/bln_result-80.png",
                            vslalt: "あなたのおサカナ度 80%",
                            imgname: "assets/img/result/img_fish-80.png",
                            imgalt: "「ギガントキプリス」タイプ",
                            text01: "大きな目で光を<br>集めて深海をスイスイ",
                            text02: "ポジティブ志向でお人好しなあなた。自然と人を引き付けてしまいます。でも、気を付けてくださいね。周りにいるのはあなたを慕う人ばかり、とは限りませんよ…",
                            text03: "本物も偽物もない♥︎信じればそれが真実。<br>あなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_80.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度80% 大きな目で光を集めて深海をスイスイ「ギガントキプリス」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 80% ＞|大きな目で光を集めて|深海をスイスイ|🎣ギガントキプリス タイプ",
                            shareUrl: "pic.twitter.com/aoQEk1253W"
                        },
                        {
                            vslname: "assets/img/result/bln_result-60.png",
                            vslalt: "あなたのおサカナ度 60%",
                            imgname: "assets/img/result/img_fish-60.png",
                            imgalt: "「リュウグウノツカイ」タイプ",
                            text01: "見た目はパンク<br>性格は温和",
                            text02: "個性的で自分をしっかり持っているあなた。穏やかで人当たりがよいこともあり、敵は滅多にいません。<br>平和な日々にちょっと刺激が欲しいくらい…？！",
                            text03: "本物も偽物もない♥︎信じればそれが真実。<br>あなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_60.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度60% 見た目はパンク性格は温和「リュウグウノツカイ」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 60% ＞|見た目はパンク|性格は温和|🎣リュウグウノツカイ タイプ",
                            shareUrl: "pic.twitter.com/AB1pXj9nYD"
                        },
                        {
                            vslname: "assets/img/result/bln_result-40.png",
                            vslalt: "あなたのおサカナ度 40%",
                            imgname: "assets/img/result/img_fish-40.png",
                            imgalt: "「マリアナスネイルフィッシュ」タイプ",
                            text01: "超深海の過酷な<br>環境に適応",
                            text02: "機転が利き、柔軟な心をもつあなた。どんなところでも生きていける強さがあります。<br>でも油断は禁物。大きな嵐は突然やってくる…？！",
                            text03: "本物も偽物もない♥︎信じればそれが真実。<br>あなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_40.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度40% 超深海の過酷な環境に適応「マリアナスネイルフィッシュ」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 40% ＞|超深海の過酷な環境に適応|🎣マリアナスネイルフィッシュ タイプ",
                            shareUrl: "pic.twitter.com/Kb37O20eqO"
                        },
                        {
                            vslname: "assets/img/result/bln_result-20.png",
                            vslalt: "あなたのおサカナ度 20%",
                            imgname: "assets/img/result/img_fish-20.png",
                            imgalt: "「ブロブフィッシュ」タイプ",
                            text01: "筋肉があまりないから<br>静かに省エネ生活",
                            text02: "まっすぐで慎重派。心を開いた相手には愛情深く接します。自分の周りは信頼できるひとばかり。騙す人なんていないし、自分が騙されるわけない！と思っていませんか…？",
                            text03: "本物も偽物もない♥︎信じればそれが真実。<br>あなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_20.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度20% 筋肉があまりないから静かに省エネ生活「ブロブフィッシュ」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 20% ＞|筋肉があまりないから|静かに省エネ生活|🎣ブロブフィッシュ タイプ",
                            shareUrl: "pic.twitter.com/UaIJQcBJom"
                        },
                        {
                            vslname: "assets/img/result/bln_result-0.png",
                            vslalt: "あなたのおサカナ度 0%",
                            imgname: "assets/img/result/img_fish-0.png",
                            imgalt: "「ダイオウイカ」タイプ。",
                            text01: "全てが規格外<br>深海の王様",
                            text02: "何事にも捕らわれず、自由で強い心をもつあなた。世間の荒波もスイスイ～嵐だってあなたにとってはさざ波にすぎません。そんなあなたには、誰かをおサカナにする才能があるかもしれませんね！",
                            text03: "本物も偽物もない♥︎信じればそれが真実。<br>あなたにぜひ観て頂きたい映画「コンフィデンスマンJP プリンセス編」7.23(木・祝)公開 ドドンッ!ダー子にまんまと騙されちゃう?!",
                            ogpname: "ogp_0.jpg",
                            ogpalt: "おサカナ度診断 深海の生きもの編 あなたのおサカナ度0% 全てが規格外深海の王様「ダイオウイカ」タイプ コンフィデンスマンJP プリンセス編",
                            share: "＜ 0% ＞|全てが規格外|深海の王様|🎣ダイオウイカ タイプ",
                            shareUrl: "pic.twitter.com/Jh44Vw1qUy"
                        }
                    ]
                }
            },
            methods: {
                replay: function () {
                    $('.layout-loading').css({ 'transition-duration': '0.3s' });
                    $('body').removeClass('is-loaded is-page-result is-loading-result result-000');
                    firstPlay = false;
                    let pathSplit = location.pathname.split('result');
                    var path = pathSplit[0];
                    // URL書き換え
                    window.history.replaceState(null, null, path);

                    setTimeout(() => {
                        router.push('question');
                    }, 600);
                }
            }
        }
        const routes = [
            { path: '/', component: Top, },
            {
                path: '/question', component: Question,
                beforeEnter: function (to, from, next) {
                    if (from.path === '/' || from.path === '/result') {
                        next();
                    } else {
                        next({ path: '/' });
                    }
                }
            },
            {
                path: '/result', component: Result,
                beforeEnter: function (to, from, next) {
                    if (from.path === '/question') {
                        next();
                    } else {
                        next({ path: '/' });
                    }
                }
            },
            { path: '*', redirect: '/' }
        ];
        const router = new VueRouter({
            // mode: 'history',
            routes: routes
        });

        // Vue.use(VueAnalytics, {
        //     id: ['UA-50122865-32', 'AW-782545300']
        // })

        new Vue({
            data: function () {
                return {
                    isTop: true,
                    page: "home",
                    result_num: "0"
                }
            },
            router: router
        }).$mount('#app')
    };

    // public
    return {
        init: init
    };
})();